<template>
    <div class="main">
        <b-overlay :show="loading" no-wrap fixed>
            <template v-slot:overlay>
                <div class="text-center">
                    <div><b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Large Spinner"></b-spinner></div>
                    <div class="loading-message">{{ loadingMessage }}</div>
                </div>
            </template>
        </b-overlay>

        <div class="container mt-sm-5 py-3 header">
            <h1 class="font-weight-bold text-center text-md-left float-md-left">Solicita una Cita</h1>
            <img src="./assets/logoValores.png" class="float-right logo d-none d-md-block" alt="BNB Valores S.A."/>
        </div>
        <div class="container mb-sm-5 py-3 body">
            <div v-if="!completed && !cancelled">
                <div class="row mb-2">
                    <div class="col-12 text-primary">Por favor llene los datos y la fecha/hora en que desea que lo contactemos.</div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <img src="./assets/side-picture.png" class="img-fluid" alt="Solicítalo aquí"/>
                        <div class="d-none d-md-block text-secondary footer-text my-3">
                            <p>Todos los campos marcados con (*) son requeridos.</p>
                            <p>Los horarios y fechas están sujetos a disponibilidad y podrían ser modificados.</p>
                            <p>BNB Valores confirmará las citas por correo electrónico, sugerimos revisar el mismo frecuentemente.</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <hr class="d-block d-md-none" />
                        <form>
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label for="fullName">(*) Nombre completo</label>
                                    <input type="text" class="form-control" id="fullName" :class="{ 'is-invalid': error.fullName || invalid.fullName }" v-model="fullName" :disabled="readonly" />
                                    <small class="form-text text-danger" v-if="error.fullName">El campo es requerido.</small>
                                    <small class="form-text text-danger" v-if="invalid.fullName">Debe ingresar al menos 5 caracteres.</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-6 col-md-12 col-lg-6 form-group">
                                    <label for="documentNumber">(*) Número de documento</label>
                                    <input type="text" class="form-control" id="documentNumber" :class="{ 'is-invalid': error.documentNumber || invalid.documentNumber }" v-model="documentNumber" :disabled="readonly" />
                                    <small class="form-text text-danger" v-if="error.documentNumber || error.documentIssuedIn">Los campos son requeridos.</small>
                                    <small class="form-text text-danger" v-if="invalid.documentNumber">Debe ingresar al menos 5 dígitos.</small>
                                </div>
                                <div class="col-6 col-sm-2 col-md-6 col-lg-2 form-group">
                                    <label for="documentComplement">Comp.</label>
                                    <input type="text" class="form-control" id="documentComplement" v-model="documentComplement" :disabled="readonly" />
                                </div>
                                <div class="col-6 col-sm-4 col-md-6 col-lg-4 form-group">
                                    <label for="documentIssuedIn">(*) Extensión</label>
                                    <select class="form-control" id="documentIssuedIn" :class="{ 'is-invalid': error.documentIssuedIn }" v-model="documentIssuedIn" :disabled="readonly">
                                        <option value="">- Seleccione -</option>
                                        <option v-for="item in documentIssuedInList" :key="item.id" :value="item.id">{{ item.value }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label for="phoneNumber">(*) Número de celular</label>
                                    <input type="text" class="form-control" id="phoneNumber" :class="{ 'is-invalid': error.phoneNumber || invalid.phoneNumber }" v-model="phoneNumber" :disabled="readonly" />
                                    <small class="form-text text-muted">Por favor, ingrese un número de teléfono válido, se le enviará un SMS de verificación.</small>
                                    <small class="form-text text-danger" v-if="error.phoneNumber">El campo es requerido.</small>
                                    <small class="form-text text-danger" v-if="invalid.phoneNumber">Debe ingresar al menos 8 dígitos.</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label for="email">(*) Correo electrónico</label>
                                    <input type="text" class="form-control" id="email" :class="{ 'is-invalid': error.email || invalid.email }" v-model="email" :disabled="readonly" />
                                    <small class="form-text text-danger" v-if="error.email">El campo es requerido.</small>
                                    <small class="form-text text-danger" v-if="invalid.email">Debe ingresar un correo electrónico válido.</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label for="service">(*) Servicio que solicita</label>
                                    <select class="form-control" id="service" :class="{ 'is-invalid': error.service }" v-model="service" :disabled="readonly">
                                        <option value="">- Seleccione -</option>
                                        <option v-for="item in servicesList" :key="item.id" :value="item.id">{{ item.value }}</option>
                                    </select>
                                    <small class="form-text text-danger" v-if="error.service">El campo es requerido.</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label for="details">(*) Ingrese los detalles de su solicitud</label>
                                    <textarea class="form-control" id="details" :class="{ 'is-invalid': error.details || invalid.details }" v-model="details" :disabled="readonly"></textarea>
                                    <small class="form-text text-danger" v-if="error.details">El campo es requerido.</small>
                                    <small class="form-text text-danger" v-if="invalid.details">Debe ingresar al menos 5 caracteres.</small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 form-group">
                                    <label>(*) Seleccione una fecha y hora tentativa para que lo contactemos</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 form-group">
                                    <b-form-datepicker :class="{ 'is-invalid': error.date }" v-model="date" class="form-control" v-bind="labels.date" locale="es" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" :date-disabled-fn="dateDisabled" :disabled="readonly"></b-form-datepicker>
                                    <small class="form-text text-danger" v-if="error.date || error.time">Los campos son requeridos.</small>
                                </div>
                                <div class="col-6 form-group">
                                    <b-form-timepicker :class="{ 'is-invalid': error.time }" v-model="time" class="form-control" v-bind="labels.time" minutes-step="15" locale="es" @context="timePickerContext" :disabled="readonly"></b-form-timepicker>
                                </div>
                            </div>
                            <div v-if="readonly">
                                <hr/>
                                <div class="row">
                                    <div class="col-12 text-center">
                                        <label for="smsCode">Por favor, ingrese el código de verificación que recibió en su teléfono celular:</label>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 offset-md-3 form-group">
                                        <input type="text" class="form-control sms-code" id="smsCode" :class="{ 'is-invalid': error.smsCode || invalid.smsCode }" v-model="smsCode" autoComplete="off" />
                                        <small class="form-text text-danger" v-if="error.smsCode">El campo es requerido.</small>
                                    </div>
                                </div>
                                <hr/>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <button type="submit" class="btn btn-primary mb-3" @click.prevent="getSMS()" v-if="!readonly">Solicitar código de verificación</button>
                                            <button type="submit" class="btn btn-primary mb-3" @click.prevent="sendForm()" v-if="readonly">Solicitar cita</button>
                                            <span class="mx-2">&nbsp;</span>
                                            <button type="button" class="btn btn-secondary mb-3" @click="cancelForm()" v-if="!readonly">Cancelar</button>
                                            <button type="button" class="btn btn-info mb-3" @click="editForm()" v-if="readonly">Editar formulario</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row d-block d-md-none">
                    <div class="col-md-6 text-secondary footer-text my-3">
                        <p>Todos los campos marcados con (*) son requeridos.</p>
                        <p>Los horarios y fechas están sujetos a disponibilidad y podrían ser modificados.</p>
                        <p>BNB Valores confirmará las citas por correo electrónico, sugerimos revisar el mismo frecuentemente.</p>
                    </div>
                </div>
            </div>

            <div v-if="completed" class="my-5">
                <complete-form></complete-form>
            </div>

            <div v-if="cancelled" class="my-5">
                <cancel-form></cancel-form>
            </div>
        </div>
    </div>
</template>

<script>
    import CompleteForm from './components/Complete.vue';
    import CancelForm from './components/Cancel.vue';

    var apiURL = process.env.NODE_ENV === 'production' ? '/ValoresCitaVirtual/' : '/';

    export default {
        components: {
            CompleteForm,
            CancelForm
        },
        data: () => ({
            fullName: '',
            documentNumber: '',
            documentComplement: '',
            documentIssuedIn: '',
            phoneNumber: '',
            email: '',
            service: '',
            details: '',
            date: '',
            time: '',

            smsCode: '',

            error: {},
            invalid: {},

            documentIssuedInList: [],
            servicesList: [],
            notAvailableDatesList: [],
            token: '',
            verificationToken: '',

            loading: true,
            loadingMessage: '',

            completed: false,
            cancelled: false,

            readonly: false,

            labels: {
                time: {
                    labelHours: 'Horas',
                    labelMinutes: 'Minutos',
                    labelSeconds: 'Segundos',
                    labelIncrement: 'Aumentar',
                    labelDecrement: 'Disminuir',
                    labelSelected: 'Hora seleccionada',
                    labelNoTimeSelected: 'Sin hora',
                    labelCloseButton: 'Cerrar'
                },
                date: {  
                    labelPrevDecade: 'Década anterior',
                    labelPrevYear: 'Año anterior',
                    labelPrevMonth: 'Mes anterior',
                    labelCurrentMonth: 'Mes actual',
                    labelNextMonth: 'Mes siguiente',
                    labelNextYear: 'Año siguiente',
                    labelNextDecade: 'Década siguiente',
                    labelToday: 'Hoy',
                    labelSelected: 'Fecha seleccionada',
                    labelNoDateSelected: 'Sin fecha',
                    labelCalendar: 'Calendario',
                    labelNav: 'Navegación',
                    labelHelp: 'Usar teclas de flechas'
                }
            }
        }),
        methods: {
            showError(message = null) {
                this.$bvModal.msgBoxOk(message ?? "Hubo un problema con el servicio, por favor contacte con soporte.", {
                    title: 'Error',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Aceptar',
                    bodyClass: 'text-center',
                    centered: true
                });
            },
            checkErrors(includeSMSCode = false) {

                let isValid = true;

                this.error = {};
                this.invalid = {};

                let fields = [
                    "fullName",
                    "documentNumber",
                    "documentIssuedIn",
                    "phoneNumber",
                    "email",
                    "service",
                    "details",
                    "date",
                    "time"
                ];

                if (includeSMSCode) fields.push("smsCode")

                for (let i in fields) {
                    if (this[fields[i]].toString().trim() == "") {
                        this.error[fields[i]] = true;
                        isValid = false;
                    }
                }

                // Email Validation
                if (!this.error.email) {
                    if (!this.$options.filters.isEmail(this.email)) {
                        this.invalid.email = true;
                        isValid = false;
                    }
                }

                // Name Validation
                if (!this.error.fullName) {
                    if (this.fullName.toString().trim().length < 5) {
                        this.invalid.fullName = true;
                        isValid = false;
                    }
                }

                // Document Validation
                if (!this.error.documentNumber) {
                    if (this.documentNumber.toString().trim().length < 5) {
                        this.invalid.documentNumber = true;
                        isValid = false;
                    }
                }

                // Phone Validation
                if (!this.error.phoneNumber) {
                    if (this.phoneNumber.toString().trim().length < 8) {
                        this.invalid.phoneNumber = true;
                        isValid = false;
                    }
                }

                // Details Validation
                if (!this.error.details) {
                    if (this.details.toString().trim().length < 5) {
                        this.invalid.details = true;
                        isValid = false;
                    }
                }


                return isValid;
            },
            dateDisabled(ymd, date) {
                const weekday = date.getDay();

                return weekday === 0 || weekday === 6 || (new Date()) >= date || this.notAvailableDatesList.includes(ymd) || date.getMonth() != (new Date()).getMonth();
            },

            // Events
            getSMS() {
                if (this.checkErrors()) {
                    this.loading = true;
                    this.loadingMessage = "Solicitando código de verificación.";
                    
                    this.$axios.post(`${apiURL}api/v1/appointment/verification`, {
                            fullName: this.fullName,
                            documentNumber: this.documentNumber,
                            documentComplement: this.documentComplement,
                            documentIssuedIn: this.documentIssuedIn,
                            phoneNumber: this.phoneNumber,
                            email: this.email,
                            service: this.service,
                            details: this.details,
                            date: this.date,
                            time: this.time
                        }, {
                            headers :{
                                Authorization: `Bearer ${this.token}`
                            }
                        })
                        .then(resp => {
                            if (resp.data.success) {
                                this.verificationToken = resp.data.token;
                                this.smsCode = "";
                                this.readonly = true;
                                this.loading = false;
                            } else {
                                if (resp.data.data?.date) {
                                    let d = new Date(resp.data.data.date);
                                    this.notAvailableDatesList.push(d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)); // YYYY-MM-DD
                                }

                                throw resp.data.message;
                            }
                        })
                        .catch(err => {
                            this.showError(!err.message ? err : err.message);
                            this.loading = false;

                            console.error(err);
                        });
                }
            },
            sendForm() {
                if (this.checkErrors(true)) {
                    this.loading = true;
                    this.loadingMessage = "Registrando su cita...";
                    
                    this.$axios.post(`${apiURL}api/v1/appointment/register`, {
                            fullName: this.fullName,
                            documentNumber: this.documentNumber,
                            documentComplement: this.documentComplement,
                            documentIssuedIn: this.documentIssuedIn,
                            phoneNumber: this.phoneNumber,
                            email: this.email,
                            service: this.service,
                            details: this.details,
                            date: this.date,
                            time: this.time,
                            smsCode: this.smsCode
                        }, {
                            headers :{
                                Authorization: `Bearer ${this.verificationToken}`
                            }
                        })
                        .then(resp => {
                            if (resp.data.success) {
                                this.completed = true;
                                this.loading = false;
                            } else {
                                if (resp.data.data?.date) {
                                    let d = new Date(resp.data.data.date);
                                    this.notAvailableDatesList.push(d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)); // YYYY-MM-DD
                                }

                                this.readonly = false;
                                this.verificationToken = '';

                                throw resp.data.message;
                            }
                        })
                        .catch(err => {
                            this.showError(!err.message ? err : err.message);
                            this.loading = false;

                            console.error(err);
                        });

                } else {
                    this.showError("Por favor verifique los campos.");
                }
            },
            timePickerContext(e){
                let hour, minute;

                if (e.hours == null && e.minutes == null) return;

                hour = e.hours == null ? 9 : e.hours;
                minute = e.minutes == null ? 0 : e.minutes;

                if (hour == 15) minute = 0;

                if ((hour > 15 && e.minutes != null) || (hour < 9 && e.minutes == null)) hour = 9;
                if ((hour < 9 && e.minutes != null) || (hour > 15 && e.minutes == null)) hour = 15;
                
                console.log(e.hours, e.minutes, hour,minute);

                this.time = ("0" + hour).slice(-2) + ":" + ("0" + minute).slice(-2);
            },
            editForm() {
                this.readonly = false;
                this.verificationToken = "";
            },
            cancelForm() {
                this.$bvModal.msgBoxConfirm('¿Desea salir del formulario?', {
                    title: 'Por favor, confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'secondary',
                    okTitle: 'Sí',
                    cancelVariant: 'primary',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    contentClass: 'text-center',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value === true) {
                            this.cancelled = true;
                        }
                    });
            }
        },
        mounted() {
            this.$axios.get(`${apiURL}api/v1/parameters`)
                .then(resp => {
                    if (resp.data.success) {
                        this.documentIssuedInList = resp.data.data.documentIssuedIn;
                        this.servicesList = resp.data.data.services;
                        this.notAvailableDatesList = resp.data.data.notAvailableDates.map(x => {
                            let d = new Date(x);
                            return d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2); // YYYY-MM-DD
                        });
                        this.token = resp.data.data.token;

                        this.loading = false;
                    } else {
                        throw resp.data.message;
                    }
                })
                .catch(err => {
                    this.showError(!err.message ? err : err.message);

                    console.error(err);
                });
        },
        watch: {
            fullName(newData) {
                newData = this.$options.filters.toName(newData);
                this.fullName = this.$options.filters.limit(newData, 100);
            },
            documentNumber(newData) {
                newData = this.$options.filters.toInteger(newData);
                this.documentNumber = this.$options.filters.limit(newData, 10);
            },
            documentComplement(newData) {
                newData = this.$options.filters.toAlphanumeric(newData);
                newData = this.$options.filters.toUpper(newData);
                this.documentComplement = this.$options.filters.limit(newData, 2);
            },
            phoneNumber(newData) {
                newData = this.$options.filters.toInteger(newData);
                this.phoneNumber = this.$options.filters.limit(newData, 15);
            },
            email(newData) {
                this.email = this.$options.filters.limit(newData, 65);
            },
            details(newData) {
                this.details = this.$options.filters.limit(newData, 1000);
            },
            smsCode(newData) {
                newData = this.$options.filters.toInteger(newData);
                this.smsCode = this.$options.filters.limit(newData, 6);
            }
        }
    }
</script>

<style lang="scss">
    @import "./bnbVariables.scss";

    .main {
        background-color: #eee;
        min-height: 100vh;
        overflow: auto;
    }

    .header {
        border: 1px solid #ccc;
        border-radius: 10px 10px 0 0;
        border-bottom: none;
        background-color: $primary;
        overflow: hidden;

        h1 {
            color: #fff;
        }
    }

    .body {
        border: 1px solid #ccc;
        border-radius: 0 0 10px 10px;
        border-top: none;
        background-color: #fff;
        overflow: hidden;
    }
    
    .logo {
        max-height: 50px;
    }

    .footer-text p {
        font-size: .8rem;
    }

    .sms-code {
        border: 2px solid #c1c1c1 !important;
        text-align: center !important;
        font-size: 2rem !important;

        &.is-invalid {
            border-color: #da6c61 !important;
        }
    }
</style>
